import type { ShareGigPayload } from '~/api/types'
import { money } from '~/calendar/ListView'

import { Frame, GigArt, Wordmark, link } from './Frame'
import { meta } from './Line'
import s from './Share.module.css'

export type GigProps = Omit<ShareGigPayload, 'kind'>

/**
 * How tall the strip under the photograph is. The stylesheet's `.art` height is its
 * complement; the two are one number in two files because CSS cannot read this one.
 */
export const STRIP = 200

/**
 * Format B: one gig, and the slide unit of the week's carousel.
 *
 * The photograph is the post: the whole width, the sheet size, and nothing written over it
 * but one solid chip naming the night — or, for a pick, that it is one. Everything else is
 * on the black strip below: the name in the reading face, the room, the time and the price
 * in the mono, the wordmark, and where to go. No price says nothing rather than "TBC".
 */
export function Gig({ host, frame, event }: GigProps) {
  return (
    <Frame format="B" frame={frame} className={s.gig}>
      <GigArt id={event.id} src={event.art} className={s.art} />
      <span className={`${s.chip} ${s.disp}`} data-probe="display">
        {event.picked
          ? `Picked · ${event.dowShort} ${event.dayNum}`
          : `${event.dowShort} ${event.dayNum} ${event.monShort}`}
      </span>
      <div className={s.strip}>
        <div className={s.words}>
          <div className={s.title}>{event.title}</div>
          <span className={`${s.meta} ${s.mono}`} data-probe="data">
            {meta(event, money(event))}
          </span>
          <div className={`${s.host} ${s.mono}`}>{link(host, `/e/${event.id}`)}</div>
        </div>
        <Wordmark />
      </div>
    </Frame>
  )
}
